'use strict';

import React from 'react';
import moment from "moment";

import { OnSchedUtils } from "../../../../../utils";

const AllocationItem = ({ element, allocation, allocations, setAllocations }) => {
  let repeatsText = '';

  if (allocation.repeat) {
    const repeats = OnSchedUtils.Internationalize(element, 'allocation_item_repeats_' + allocation.repeats);

    repeatsText = repeats;

    // if (allocation.repeats === "W") {
    //   const addDay = (i, day) => {
    //     const { weekdays } = allocation;
    //     let days = ''
    
    //     if (weekdays.includes(i)) {
    //       let amp = ''
    //       let comma = ''
    //       // If more days follow
    //       if ((weekdays.length - 2) > weekdays.indexOf(i))
    //         comma = ', '
          
    //       // If more than 1 day, and last day
    //       if (weekdays.length > 1 && 
    //           (weekdays.length - 1) === weekdays.indexOf(i)
    //         ) {
    //         amp = ' & '
    //       }
            
    //       days = amp + day + comma
    //     }
    //     return days
    //   }
      
    //   let weekdayDays = '';

    //   const daysOfWeek = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

    //   let days = daysOfWeek.map(d => OnSchedUtils.Internationalize(element, 'consumer_availability_weekday_' + d).slice(0,3))

    //   days.map((day, i) => 
    //     weekdayDays += addDay(i.toString(), day)
    //   )

    //   repeatsText += ' on ' + weekdayDays;
    // }
  }
  
  console.log('allocation', allocation)

  return (
    <tr className="AllocationItem" id={allocation.id}>
      <td>
        <input 
          type="date" 
          name="startDate"
          disabled
          defaultValue={moment(allocation.startDate).format('YYYY-MM-DD')} 
          onChange={null}
        />
      </td>
      
      <td>
        <input 
          type="date" 
          name="endDate"
          disabled
          defaultValue={moment(allocation.endDate).format('YYYY-MM-DD')} 
          onChange={null}
        />
      </td>
      
      <td className='hideOnMobile'>
        <select name="startTime" disabled defaultValue={allocation.startTime} onChange={null}>
          {Object.values(OnSchedUtils.AvailableTimes()).map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
      </td>
      <td className='hideOnMobile'>
        <select name="endTime" disabled defaultValue={allocation.endTime} onChange={null}>
          {Object.values(OnSchedUtils.AvailableTimes()).map(t => <option key={t.value} value={t.value}>{t.label}</option>)}
        </select>
      </td>
      <td className='hideOnMobile'>
        <input 
          type="text" 
          name="repeatsText"
          value={repeatsText} 
          readOnly
          onChange={null}
        />
      </td>
      <td>
        <i onClick={null} className="fa-light fa-pencil onsched-primary-color" />
      </td>
      <td>
        <i onClick={null} className="fa-light fa-trash onsched-danger-color" />
      </td>
    </tr>
  )
}

export default AllocationItem

  // OLD CODE -- DELETE WHEN FIXED
  // const change = e => {
  //   const idx = allocations.indexOf(allocations.filter(b => b.id === allocation.id)[0]);
  //   let newBlocks = allocations;
    
  //   if (e.target.name === 'startTime' || e.target.name === 'endTime') {
  //     newBlocks[idx][e.target.name] = parseInt(e.target.value);
  //   }
  //   else {
  //     newBlocks[idx][e.target.name] = e.target.value;
  //   }

  //   onschedState.setState(Object.assign(onschedState.state, { allocations: newBlocks }));
  // }

  // const trash = () => {
  //   const newBlocks = onschedState.state.allocations.filter(b => b.id !== allocation.id);
  //   onschedState.setState(Object.assign(onschedState.state, { allocations: newBlocks }));
  //   document.getElementById(allocation.id)?.classList.add('removed');
  // }